import type { FC } from 'react';

type NavBarStatusProps = {
  isOpen: boolean;
  showLabel?: boolean;
  size?: 'sm' | 'md' | 'lg';
};

const NavBarStatus: FC<NavBarStatusProps> = ({ isOpen, showLabel = true, size = 'sm' }) => {
  const sizeClasses = {
    sm: 'w-2 h-2',
    md: 'w-4 h-4',
    lg: 'w-5 h-5',
  };

  return (
    <div className="flex justify-center items-center text-sm whitespace-pre">
      <div
        className={`rounded-full shadow-md ${sizeClasses[size]} ${showLabel ? 'mr-2' : ''} ${
          isOpen ? 'shadow-color-green bg-color-green' : 'shadow-color-red_notification bg-color-red_notification'
        }`}
      ></div>
      {showLabel && (isOpen ? 'Abierto' : 'Cerrado temporalmente')}
    </div>
  );
};

export default NavBarStatus;
